import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";

import {
  StyledTableCell,
  StyledTableRow,
} from "components/atoms/table/StyledTable";

const ReportLocationOccupationTable = (props) => {
  const rows = props.rows;
  const rowsLength = rows.length;

  if (rowsLength === 0) {
    return (
      <Typography sx={{ color: "error.main" }}>Não há registros.</Typography>
    );
  } else {
    const result = rows.result;
    const cells = result.map((row) => {
      return (
        <StyledTableRow key={row.idLocal} id={row.idLocal}>
          <StyledTableCell>{`${row.Bloco} - ${row.numero}`}</StyledTableCell>
          <StyledTableCell>{row.percent_comum}</StyledTableCell>
          <StyledTableCell>{row.percent_ensalamento}</StyledTableCell>
          <StyledTableCell>{row.percent_monitoria}</StyledTableCell>
          <StyledTableCell>{row.percent_outras}</StyledTableCell>
          <StyledTableCell>{row.percent_livre}</StyledTableCell>
        </StyledTableRow>
      );
    });
    return (
      <Box sx={{ mb: 2 }}>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="tabela de recursos">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>Local</StyledTableCell>
                <StyledTableCell>Comum</StyledTableCell>
                <StyledTableCell>Ensalamento</StyledTableCell>
                <StyledTableCell>Monitoria</StyledTableCell>
                <StyledTableCell>Outros</StyledTableCell>
                <StyledTableCell>Livre</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>{cells}</TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }
};

ReportLocationOccupationTable.propTypes = {
  rows: PropTypes.array.isRequired,
};

export default ReportLocationOccupationTable;
